import { render, staticRenderFns } from "./drawer-element.vue?vue&type=template&id=133d16d1&scoped=true&"
import script from "./drawer-element.vue?vue&type=script&lang=js&"
export * from "./drawer-element.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133d16d1",
  null
  
)

export default component.exports